import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ContentService } from '../../../cms/content.service';

@Component({
    selector: 'app-team',
    templateUrl: './team.component.html',
    styleUrls: ['./team.component.scss'],
    standalone: false
})
export class TeamComponent implements OnInit {

    teamMembers: Array<{ image: string | null; name: string; role: string }> = [];

    constructor(
        private viewportScroller: ViewportScroller,
        private contentService: ContentService
    ) {}

    public onClick(elementId: string): void {
        this.viewportScroller.scrollToAnchor(elementId);
    }

    ngOnInit(): void {
        this.contentService.getTeam().subscribe(response => {
            this.teamMembers = response.data.map(member => ({
                image: this.contentService.assetUrl(member.image),
                name: member.name,
                role: member.role
            }));
        });
    }

    isDirector(role: string): boolean {
        return role?.trim().toLocaleLowerCase('es') === 'director';
    }
}
